import getSettings from '../utils/settings';

const computeResultSocialCharges = (result) => Math.max(getSettings('global.socialChargesRate') * result, 0);

export default computeResultSocialCharges;
